<template>
  <div class="container">
      <div class="autocomplete">
        <input 
          ref="autocompleteInput"
          class="form-control2 px-3"
          type="text"
          v-model="query"
          @input="onInput"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter.prevent="onEnter"
          placeholder="Country"/>
      </div>

    <!-- Suggestion List -->
    <div v-if="suggestions.length" class="autocomplete-items">
      <div
        v-for="(suggestion, index) in suggestions"
        :key="index"
        :class="['suggestion-item', index === activeIndex ? 'active' : '']"
        @click="selectSuggestion(suggestion)">
        {{ suggestion }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      query: null,
      suggestions: [],
      activeIndex: -1,
      countries: [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda",
        "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", /* more countries */
      ],
    };
  },
  methods: {
    onInput() {

      const val = this.query;
      if (!val) {
        this.suggestions = [];
        return;
      }
      this.suggestions = this.countries.filter((country) =>
        country.toLowerCase().startsWith(val.toLowerCase())
      );

      // format all suggestions to lowercase
      this.suggestions = this.suggestions.map((suggestion) => suggestion.toLowerCase());

    // Reset the active index when input changes
      this.activeIndex = -1; 
    },

    onArrowDown() {
      this.activeIndex = (this.activeIndex + 1) % this.suggestions.length; // Loop to the top
      this.updateInputValue();
    },
    onArrowUp() {
      this.activeIndex = (this.activeIndex - 1 + this.suggestions.length) % this.suggestions.length; // Loop to the bottom
      this.updateInputValue();
    },
    
    updateInputValue() {
      if (this.activeIndex >= 0) {
        this.query = this.suggestions[this.activeIndex]; // Update the input field
        this.setCursorToEnd();
      }
    },

    setCursorToEnd() {
      const input = this.$refs.autocompleteInput; // Access the input directly via ref
      if (input) {
        input.focus(); // Ensure the input is focused

        // Use setTimeout to ensure that the input value update has fully propagated
        setTimeout(() => {
          console.log("Setting cursor for:", input.value, "Length:", input.value.length);

          input.setSelectionRange(input.value.length, input.value.length);
        }, 0);
      }
    },

//     onArrowDown() {
//     if (this.activeIndex < this.suggestions.length - 1) {
//       this.activeIndex++;
//     } else {
//       this.activeIndex = 0; 
//     }

//     this.updateInputValue();

//   },
//   onArrowUp() {
//     if (this.activeIndex > 0) {
//       this.activeIndex--;
//     } else {
//       this.activeIndex = this.suggestions.length - 1; 
//     }

//     this.updateInputValue();

//   },
//     updateInputValue() {
//       this.query = this.activeIndex >= 0 ? this.suggestions[this.activeIndex] : this.query;
//       this.$nextTick(() => {
//         const input = document.querySelector('.autocomplete input');
//         input.setSelectionRange(this.query.length, this.query.length); 
//       });
//     },

    onEnter() {
      if (this.activeIndex > -1) {
        this.selectSuggestion(this.suggestions[this.activeIndex]);
      }
    },

    selectSuggestion(suggestion) {
      this.query = suggestion;
      this.suggestions = [];
    },

    handleSubmit() {
      console.log("Submitted:", this.query);
    },

  },
};
</script>

<style scoped>
/* Ensure the autocomplete container is correctly positioned */
.autocomplete {
  position: relative;
}

/* Suggestions dropdown with a higher z-index and defined position */
.autocomplete-items {
  /* position: absolute; */
  z-index: 1050; /* Ensure it's above other elements */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Individual suggestion items */
.suggestion-item {
  padding: 5px 15px;
  cursor: pointer;
}

/* Highlight active suggestion */
.suggestion-item.active {
  background-color: #e9e9e9;
  color: black;
}

/* Hover effect */
.suggestion-item:hover {
  background-color: #e9e9e9;
  color: black;
}

/* Debugging */
/* .suggestion-item {
  border-bottom: 1px solid #ddd;
} */

/* Ensure body overflow does not affect absolute positioning */
body {
  overflow-x: visible;
}
</style>
